////////LIBRARY/////////
import React, { useState } from 'react'
import styled from 'styled-components'
import { isNull, isEmpty } from 'lodash'
import { Transition } from 'react-transition-group'

/////////STYLED/////////
const InitKioskBusinessDistributorWrapper = styled.div`
	width: 100px;
	height: 40px;
	margin: auto;
	border: ${(props) =>
		({ transitionstate }) => {
			switch (transitionstate) {
				case 'entering':
					return `1px solid transparent`
				case 'entered':
					return `1px solid ${props.theme.colors.input.border}`
				case 'exiting':
					return `1px solid transparent`
				case 'exited':
					return `1px solid transparent`
				default:
					return `1px solid transparent`
			}
		}};
	transition: all 0.1s;
`
const InitKioskBusinessDistributorBorder = styled.img`
	max-width: 100%;
	max-height: 100%;
	vertical-align: middle;
`
const ValignHelper = styled.div`
	display: inline-block;
	height: 100%;
	vertical-align: middle;
`
/////////STYLED/////////

const InitKioskBusinessDistributor = (props) => {
	const [hovered, setHovered] = useState(false)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return !isEmpty(props.row.distributorPicture) ? (
		<Transition
			in={hovered}
			timeout={{
				appear: 0,
				enter: 0,
				exit: 300,
			}}
		>
			{(state) => (
				<InitKioskBusinessDistributorWrapper
					transitionstate={state}
					onMouseEnter={() => setHovered(true)}
					onMouseLeave={() => setHovered(false)}
				>
					<ValignHelper />
					<InitKioskBusinessDistributorBorder src={`data:image/*;base64,${props.row.distributorPicture}`} />
				</InitKioskBusinessDistributorWrapper>
			)}
		</Transition>
	) : (
		'-'
	)
}

InitKioskBusinessDistributor.propTypes = {}

InitKioskBusinessDistributor.defaultPropTypes = {}

export default InitKioskBusinessDistributor
